import axios from "axios";
import { Outlet } from "react-router-dom";
import "./App.css";
import Navbar from "components/navbar/Navbar";
import { useAppDispatch } from "hooks";
import { styled } from "styled-components";
import Footer from "components/footer/Footer";

axios.defaults.baseURL = process.env["REACT_APP_API_BASE_URL"];

const SetUpAxiosInterceptors = (dispatch: any) => {
  axios.interceptors.response.use(
    function (response: any) {
      return response;
    },
    function (error: any) {
      if (error.response && error.response.status === 400) {
        let errorMessages = [];
        for (const property in error.response.data.errors) {
          errorMessages.push(error.response.data.errors[property][0]);
        }
        if (errorMessages.length > 0)
          error.message = errorMessages.join("\r\n");
        else if (error.response.data.detail)
          error.message = error.response.data.detail;
      }
      return Promise.reject(error);
    },
  );
};

const OuterWrapper = styled.div`
  background: var(--bs-body-bg);
  border: solid 2px var(--border-color);
  margin: 20px 20px 10px;
  flex: 1;
  display: flex;
`;

const InnerWrapper = styled(OuterWrapper)`
  margin: 5px;
  flex-direction: column;
`;

const Logo = styled.div`
  text-align: center;
  height: 24px;
  background: var(--bs-body-bg);
  margin-top: -16px;
  padding: 0 10px;
  margin-bottom: -8px;
  align-self: start;
  margin-left: 10px;

  @media (min-width: 768px) {
    align-self: center;
    margin-left: 0;
  }
`;

function App() {
  const dispatch = useAppDispatch();

  SetUpAxiosInterceptors(dispatch);

  return (
    <div className="App" suppressHydrationWarning>
      <OuterWrapper>
        <InnerWrapper>
          <Logo>TOOLWEAVER.COM</Logo>
          <Navbar />
          <Outlet />
        </InnerWrapper>
      </OuterWrapper>
      <Footer />
    </div>
  );
}
export default App;
